require('../core/grpn-lazyload');

module.exports = Groupon.Utils.lazyLoadImages = function(options, triggerClass) {
  var $el;
  if (triggerClass == null) {
    triggerClass = '.lazy-load';
  }
  if (($el = $(triggerClass)).length) {
    $el.lazyload(options);
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL3NyYy9mcm9udGVuZC9oZWxwZXIvbGF6eUxvYWRJbWFnZXMuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL3NraW0vc2xzL3NyYy9mcm9udGVuZC9oZWxwZXIvbGF6eUxvYWRJbWFnZXMuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQUEsQ0FBUSx1QkFBUjs7QUFFQSxNQUFNLENBQUMsT0FBUCxHQUFpQixPQUFPLENBQUMsS0FBSyxDQUFDLGNBQWQsR0FBK0IsU0FBQyxPQUFELEVBQVUsWUFBVjtBQUM5QyxNQUFBOztJQUR3RCxlQUFlOztFQUN2RSxJQUF5QixDQUFDLEdBQUEsR0FBTSxDQUFBLENBQUUsWUFBRixDQUFQLENBQXVCLENBQUMsTUFBakQ7SUFBQSxHQUFHLENBQUMsUUFBSixDQUFhLE9BQWIsRUFBQTs7QUFEOEMifQ==
